(function () {
  'use strict';

  /* ================================================
     NEYSA THEME JS — Full Shopify AJAX Integration
  ================================================ */

  // === Mobile Menu ===
  var mobileMenuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileNavClose = document.querySelectorAll('[data-mobile-nav-close]');

  if (mobileMenuToggle && mobileNav) {
    mobileMenuToggle.addEventListener('click', function () {
      mobileNav.classList.add('active');
      document.body.style.overflow = 'hidden';
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
    });
    mobileNavClose.forEach(function (btn) {
      btn.addEventListener('click', function () {
        mobileNav.classList.remove('active');
        document.body.style.overflow = '';
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      });
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('active');
        document.body.style.overflow = '';
        mobileMenuToggle.setAttribute('aria-expanded', 'false');
      });
    });
    // Escape key closes mobile menu
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (mobileNav.classList.contains('active')) {
          mobileNav.classList.remove('active');
          document.body.style.overflow = '';
          mobileMenuToggle.setAttribute('aria-expanded', 'false');
          mobileMenuToggle.focus();
        }
      }
    });
  }

  // === Search Overlay ===
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchClose = document.querySelector('[data-search-close]');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function (e) {
      e.preventDefault();
      searchOverlay.classList.add('active');
      var input = searchOverlay.querySelector('input');
      if (input) input.focus();
    });
    if (searchClose) {
      searchClose.addEventListener('click', function () {
        searchOverlay.classList.remove('active');
      });
    }
    searchOverlay.addEventListener('click', function (e) {
      if (e.target === searchOverlay) searchOverlay.classList.remove('active');
    });
    // Escape key closes search
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
        searchOverlay.classList.remove('active');
        if (searchToggle) searchToggle.focus();
      }
    });
  }

  // === Cart Drawer ===
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartToggle = document.querySelector('[data-cart-toggle]');
  var cartDrawerClose = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeCartDrawer() {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  // Make cart drawer functions globally accessible
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  if (cartDrawer && cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer();
    });
    cartDrawerClose.forEach(function (btn) {
      btn.addEventListener('click', closeCartDrawer);
    });
  }

  // === Cart AJAX Helpers ===
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function updateCartTotal(totalPrice) {
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(totalPrice);
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? amount + ' ' + window.Shopify.currency.active
      : 'Rs. ' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateFreeShippingBar(cart) {
    var bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold') || '300000', 10);
    var total = cart.total_price;
    var fill = document.querySelector('[data-shipping-fill]');
    var msg = document.querySelector('[data-shipping-message]');
    if (total >= threshold) {
      if (fill) fill.style.width = '100%';
      if (msg) msg.textContent = "";
    } else {
      var remaining = threshold - total;
      var pct = Math.min(100, Math.round((total / threshold) * 100));
      var remainingFormatted = 'Rs. ' + (remaining / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (fill) fill.style.width = pct + '%';
      if (msg) msg.textContent = remainingFormatted + ' away from free shipping!';
    }
  }

  function refreshCartDrawer() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateCartTotal(cart.total_price);
        renderCartItems(cart);
        updateFreeShippingBar(cart);
      })
      .catch(function (err) {
        console.warn('[Neysa] Cart refresh error:', err.message);
      });
  }

  // Make refreshCartDrawer globally accessible
  window.refreshCartDrawer = refreshCartDrawer;

  function renderCartItems(cart) {
    var container = document.querySelector('[data-cart-items]');
    if (!container) return;

    if (cart.item_count === 0) {
      container.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary">Continue Shopping</a></div>';
      var footer = document.querySelector('.cart-drawer__footer');
      if (footer) footer.style.display = 'none';
      return;
    }

    var footer = document.querySelector('.cart-drawer__footer');
    if (footer) footer.style.display = '';

    var html = '';
    cart.items.forEach(function (item, index) {
      var lineIndex = index + 1;
      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="cart-drawer__item-variant">' + item.variant_title + '</span>'
        : '';
      var imgUrl = item.image ? getSizedImageUrl(item.image, '200x') : item.featured_image ? item.featured_image.url : '';
      var imgHtml = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + escapeHtml(item.title) + '">'
        : '<svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';
      html += '<div class="cart-drawer__item" data-line-item="' + lineIndex + '">'
        + '<div class="cart-drawer__item-image">' + imgHtml + '</div>'
        + '<div class="cart-drawer__item-info">'
        + '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>'
        + variantHtml
        + '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>'
        + '<div class="cart-drawer__quantity">'
        + '<button class="quantity-btn" data-quantity-change="' + lineIndex + '" data-direction="minus">−</button>'
        + '<span class="quantity-display">' + item.quantity + '</span>'
        + '<button class="quantity-btn" data-quantity-change="' + lineIndex + '" data-direction="plus">+</button>'
        + '</div></div>'
        + '<button class="cart-drawer__item-remove" data-remove-item="' + lineIndex + '" aria-label="Remove">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'
        + '</button></div>';
    });
    container.innerHTML = html;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      var prefix = url.split(match[0]);
      return prefix[0] + '_' + size + '.' + match[1] + (match[2] || '');
    }
    return url;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  // === Cart Drawer: Quantity Change ===
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quantity-change]');
    if (!btn) return;
    var line = parseInt(btn.getAttribute('data-quantity-change'));
    var direction = btn.getAttribute('data-direction');
    var display = btn.parentElement.querySelector('.quantity-display');
    var current = display ? parseInt(display.textContent) : 1;
    var newQty = direction === 'minus' ? Math.max(0, current - 1) : current + 1;

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed');
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateCartTotal(cart.total_price);
        renderCartItems(cart);
      })
      .catch(function (err) {
        console.warn('[Neysa] Quantity change error:', err.message);
      });
  });

  // === Cart Drawer: Remove Item ===
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-item]');
    if (!btn) return;
    var line = parseInt(btn.getAttribute('data-remove-item'));

    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart remove failed');
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateCartTotal(cart.total_price);
        renderCartItems(cart);
      })
      .catch(function (err) {
        console.warn('[Neysa] Remove item error:', err.message);
      });
  });

  // === Quantity Selectors (Product Page) ===
  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-quantity-minus]')) {
      var input = e.target.parentElement.querySelector('.quantity-input');
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    }
    if (e.target.matches('[data-quantity-plus]')) {
      var input = e.target.parentElement.querySelector('.quantity-input');
      if (input) input.value = parseInt(input.value) + 1;
    }
  });

  // === AJAX Add to Cart ===
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.product__form');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not add to cart');
        return r.json();
      })
      .then(function () {
        refreshCartDrawer();
        openCartDrawer();
        if (submitBtn) {
          submitBtn.textContent = 'Added ✓';
          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);
        }
      })
      .catch(function (err) {
        if (submitBtn) {
          submitBtn.textContent = 'Error – Try Again';
          submitBtn.disabled = false;
          setTimeout(function () { submitBtn.textContent = originalText; }, 3000);
        }
      });
  });

  // === Shop By Type Tabs ===
  var tabTriggers = document.querySelectorAll('[data-tab-trigger]');
  tabTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var tabId = this.getAttribute('data-tab-trigger');
      var section = this.closest('.shop-by-type');
      if (!section) return;

      section.querySelectorAll('.shop-by-type__tab').forEach(function (t) { t.classList.remove('active'); });
      section.querySelectorAll('.shop-by-type__panel').forEach(function (p) { p.classList.remove('active'); });

      this.classList.add('active');
      var panel = section.querySelector('[data-tab-panel="' + tabId + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  // === Hero Slider Swiper Init ===
  function initHeroSwipers() {
    document.querySelectorAll('[data-hero-swiper]').forEach(function (el) {
      if (typeof Swiper === 'undefined') return;
      var autoplayEnabled = el.getAttribute('data-autoplay') !== 'false';
      var speed = parseInt(el.getAttribute('data-speed') || '4500', 10);
      new Swiper(el, {
        loop: true,
        speed: 1000,
        autoplay: autoplayEnabled ? { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: true } : false,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev')
        },
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true
        },
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide'
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSwipers);
  } else {
    initHeroSwipers();
  }

  // === Collection Swiper Init ===
  document.querySelectorAll('[data-swiper-collection]').forEach(function (el) {
    if (typeof Swiper !== 'undefined') {
      new Swiper(el, {
        slidesPerView: 2,
        spaceBetween: 16,
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev')
        },
        breakpoints: {
          320: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 3, spaceBetween: 12 },
          1024: { slidesPerView: 4, spaceBetween: 16 },
          1280: { slidesPerView: 5, spaceBetween: 16 }
        }
      });
    }
  });

  // === Product Gallery Thumbnails ===
  document.querySelectorAll('[data-thumb-index]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = this.getAttribute('data-thumb-src');
      var mainImage = document.querySelector('[data-product-main-image]');
      if (mainImage && src && mainImage.tagName === 'IMG') {
        mainImage.src = src;
        mainImage.srcset = src;
        document.querySelectorAll('[data-thumb-index]').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      }
    });
  });

  // === Product Variant / Size Selection ===
  document.querySelectorAll('.product__size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionGroup = this.closest('.product__option-values');
      optionGroup.querySelectorAll('.product__size-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');

      // Update hidden variant select based on option combo
      var form = this.closest('.product__form');
      if (!form) return;
      var selectedOptions = [];
      form.querySelectorAll('.product__option').forEach(function (optionDiv) {
        var activeBtn = optionDiv.querySelector('.product__size-btn.active');
        if (activeBtn) selectedOptions.push(activeBtn.getAttribute('data-option-value'));
      });

      var variantSelect = form.querySelector('[data-variant-select]');
      if (!variantSelect) return;
      for (var i = 0; i < variantSelect.options.length; i++) {
        var optionText = variantSelect.options[i].textContent.trim();
        var match = selectedOptions.every(function (val) {
          return optionText.indexOf(val) !== -1;
        });
        if (match) {
          variantSelect.selectedIndex = i;
          var selectedOption = variantSelect.options[i];
          var isAvailable = !selectedOption.disabled;

          // Update price display
          var priceEl = document.querySelector('[data-product-price]');
          var priceData = selectedOption.getAttribute('data-price');
          if (priceEl && priceData) {
            priceEl.innerHTML = '<span class="product__price-regular">' + priceData + '</span>';
          }

          // Update availability text
          var availabilityEl = document.querySelector('.product__availability');
          if (availabilityEl) {
            if (isAvailable) {
              availabilityEl.textContent = 'In Stock';
              availabilityEl.className = 'product__availability product__availability--in-stock';
            } else {
              availabilityEl.textContent = 'Sold Out';
              availabilityEl.className = 'product__availability product__availability--sold-out';
            }
          }

          // Update Add to Cart button
          var addToCartBtn = form.querySelector('.product__add-to-cart');
          if (addToCartBtn) {
            addToCartBtn.disabled = !isAvailable;
            addToCartBtn.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
          }

          break;
        }
      }
    });
  });

  // === Collection Sort ===
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    // Preserve current sort on load
    var urlParams = new URLSearchParams(window.location.search);
    var currentSort = urlParams.get('sort_by');
    if (currentSort) sortSelect.value = currentSort;

    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // === Newsletter Popup ===
  var popup = document.querySelector('[data-newsletter-popup]');
  if (popup) {
    var shown = sessionStorage.getItem('neysa_popup_shown');
    if (!shown) {
      var delay = parseInt(popup.getAttribute('data-delay') || '5', 10) * 1000;
      setTimeout(function () {
        popup.classList.add('active');
      }, delay);
      sessionStorage.setItem('neysa_popup_shown', '1');
    }
    popup.querySelectorAll('[data-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        popup.classList.remove('active');
      });
    });
  }

  // === Wishlist (localStorage) ===
  var wishlist = JSON.parse(localStorage.getItem('neysa_wishlist') || '[]');

  function updateWishlistCount() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = wishlist.length;
    });
  }
  updateWishlistCount();

  // Mark wishlisted on load
  wishlist.forEach(function (id) {
    document.querySelectorAll('[data-wishlist-toggle="' + id + '"]').forEach(function (btn) {
      btn.classList.add('active');
    });
  });

  document.addEventListener('click', function (e) {
    var wishBtn = e.target.closest('[data-wishlist-toggle]');
    if (wishBtn) {
      e.preventDefault();
      e.stopPropagation();
      var productId = wishBtn.getAttribute('data-wishlist-toggle');
      var idx = wishlist.indexOf(productId);
      if (idx > -1) {
        wishlist.splice(idx, 1);
        wishBtn.classList.remove('active');
      } else {
        wishlist.push(productId);
        wishBtn.classList.add('active');
      }
      localStorage.setItem('neysa_wishlist', JSON.stringify(wishlist));
      updateWishlistCount();
    }
  });

  // === Sticky Header ===
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 20px rgba(0,0,0,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    }, { passive: true });
  }

  // === Init: Fetch cart count on load ===
  refreshCartDrawer();

})();
